import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-equal",
  "use": "icon-equal-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-equal\"><path d=\"M754.874 451.025H269.126a39.47 39.47 0 0 1 0-78.661h485.748a39.47 39.47 0 0 1 0 78.661zm0 251.346H269.126a39.47 39.47 0 0 1 0-78.662h485.748a39.47 39.47 0 0 1 0 78.662z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol